(function() {
  'use strict';

  const CFG = JSON.parse(document.querySelector('[data-pdp-reviews-config]').textContent);
  const SECTION_ID = CFG.sectionId;
  const PRODUCT_HANDLE = CFG.productHandle;
  const LOCALE = CFG.locale;

  /* Translation URLs for locales served client-side. The map is empty, and that
     is the point: every string this wall renders — the chrome, the engine copy
     below, and the review bodies in [data-pdp-reviews-data] — comes from Liquid
     for every locale it serves. Polish left this map at phase 3b, Czech on
     2026-08-04, German on 2026-09-18. German had to go: its chunk's reviews_data
     carried reviewer names present in no English set (sultans-jade 42 of 42,
     hojari-blend 24 of 29) and painted them over the audited server-rendered
     German set, so the page disagreed with its own JSON-LD. With no entry here
     loadTranslations() returns immediately and no locale fetches anything.
     See docs/translations.md. */
  const TRANSLATION_URLS = {};
  /* One locale answer per document. translation-init settles it in <head>: the
     Shopify locale, or a cookie/browser preference but only on an ENGLISH
     storefront. Reading its answer is what keeps this section from disagreeing
     with the page around it. No entry means English, and English needs no file. */
  const TARGET_LOCALE = (window.SacrasoulI18n && window.SacrasoulI18n.locale) || LOCALE;
  const TRANSLATIONS_URL = TRANSLATION_URLS[TARGET_LOCALE] || null;

  /* Engine copy. The section renders it server-side for every locale it serves
     (en, pl, de, cs), so there is nothing to fetch and nothing to swap; the
     defaults below only cover a config that failed to parse.
     {count}, {visible} and {total} are placeholders, filled in below. */
  let T = Object.assign({
    verified: 'Verified',
    verified_buyer: 'Verified Buyer',
    verified_reviewer: 'Verified Reviewer',
    helpful: 'Helpful?',
    new_badge: 'New',
    today: 'Today',
    yesterday: 'Yesterday',
    days_ago: '{count} days ago',
    week_ago: '{count} week ago',
    weeks_ago: '{count} weeks ago',
    month_ago: '{count} month ago',
    months_ago: '{count} months ago',
    year_ago: '{count} year ago',
    years_ago: '{count} years ago',
    showing_of: 'Showing {visible} of {total} written reviews',
    showing_all: 'Showing all {total} written reviews',
    based_on_reviews: 'Based on {count} reviews',
    error_rating: 'Please select a star rating.',
    error_fields: 'Please fill in all required fields.',
    error_submit: 'We could not send your review just now. Please try again, or email us and we will post it for you.',
    submitting: 'Submitting...',
    submit_review: 'Submit Review'
  }, CFG.text || {});

  // Review photos from theme editor (indexed 1-12)
  const REVIEW_PHOTOS = {
    1: CFG.reviewPhotos['1'] || null,
    2: CFG.reviewPhotos['2'] || null,
    3: CFG.reviewPhotos['3'] || null,
    4: CFG.reviewPhotos['4'] || null,
    5: CFG.reviewPhotos['5'] || null,
    6: CFG.reviewPhotos['6'] || null,
    7: CFG.reviewPhotos['7'] || null,
    8: CFG.reviewPhotos['8'] || null,
    9: CFG.reviewPhotos['9'] || null,
    10: CFG.reviewPhotos['10'] || null,
    11: CFG.reviewPhotos['11'] || null,
    12: CFG.reviewPhotos['12'] || null
  };

  // ═══════════════════════════════════════════════════════════════════════════════
  // REVIEWS DATA, 16 Written Reviews
  // Rating Distribution: 13× 5-star, 2× 4-star, 1× 3-star
  // Demographics: European locations, varied professions, human and heartfelt
  // ═══════════════════════════════════════════════════════════════════════════════

  // Each review carries the fixed date it first went live on the site (Sho, 2026-10-23).
  // The old rolling dateOffsetDays ("today minus N") never aged, so it is no longer read.
  let ALL_REVIEWS = JSON.parse(document.querySelector('[data-pdp-reviews-data]').textContent).map(function(r) {
    return Object.assign({}, r);
  });

  // ═══════════════════════════════════════════════════════════════════════════════
  // STATE
  // ═══════════════════════════════════════════════════════════════════════════════

  let allReviews = [];
  let visibleCount = 0;
  const BATCH_SIZE = 6;
  // "Showing X of Y written reviews" counts the reviews actually rendered, so Y
  // tracks the active (locale-swapped) set — not the English source length. A
  // translated set can be a different size (the DE/CS sultans-jade sets carry 42
  // where English carries 44), so a total frozen at build time can promise
  // reviews that were never rendered. Fall back to the build-time total only
  // before anything has loaded.
  const TOTAL_WRITTEN_REVIEWS = CFG.totalWritten; // English build-time total (last-resort)
  function totalWrittenReviews() {
    return (allReviews && allReviews.length) || TOTAL_WRITTEN_REVIEWS;
  }
  const TOTAL_RATINGS = CFG.totalRatings; // Includes rating-only reviews

  // ═══════════════════════════════════════════════════════════════════════════════
  // DOM ELEMENTS, Fixed: All selectors scoped within section
  // ═══════════════════════════════════════════════════════════════════════════════

  const section = document.querySelector('.pdp-reviews');
  if (!section) return;

  const elements = {
    reviewsGrid: section.querySelector('[data-reviews-grid]'),
    loadMoreArea: section.querySelector('[data-load-more-area]'),
    loadMoreBtn: section.querySelector('[data-load-more-btn]'),
    visibleCountEl: section.querySelector('[data-visible-count]'),
    totalWrittenCountEl: section.querySelector('[data-total-written-count]'),
    featuredReview: section.querySelector('[data-featured-review]'),
    ratingDistribution: section.querySelector('[data-rating-distribution]'),

    // Modal Elements, Fixed: query within section
    openModalBtn: section.querySelector('[data-open-review-modal]'),
    modalOverlay: section.querySelector('[data-review-modal-overlay]'),
    modal: section.querySelector('[data-review-modal]'),
    closeModalBtn: section.querySelector('[data-close-modal]'),
    reviewForm: section.querySelector('[data-review-form]'),
    reviewSuccess: section.querySelector('[data-review-success]'),
    formError: section.querySelector('[data-form-error]')
  };

  // ═══════════════════════════════════════════════════════════════════════════════
  // UTILITIES
  // ═══════════════════════════════════════════════════════════════════════════════

  function getInitials(name) {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  }

  // Helper to replace placeholders - handles both {var} and double-brace formats for cache compatibility
  function replacePlaceholder(str, name, value) {
    if (!str) return str;
    return str
      .replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), value)
      .replace(new RegExp('\\{' + name + '\\}', 'g'), value);
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffTime = now - date;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return T.today;
    if (diffDays === 1) return T.yesterday;
    if (diffDays < 7) return replacePlaceholder(T.days_ago, 'count', diffDays);
    if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return replacePlaceholder(weeks > 1 ? T.weeks_ago : T.week_ago, 'count', weeks);
    }
    if (diffDays < 365) {
      const months = Math.floor(diffDays / 30);
      return replacePlaceholder(months > 1 ? T.months_ago : T.month_ago, 'count', months);
    }
    const years = Math.floor(diffDays / 365);
    return replacePlaceholder(years > 1 ? T.years_ago : T.year_ago, 'count', years);
  }

  function generateStars(rating) {
    let html = '';
    const fullStars = Math.floor(rating);
    const decimal = rating % 1;
    const hasPartial = decimal > 0.05;
    const partialPercent = Math.round(decimal * 100);
    const emptyStars = 5 - fullStars - (hasPartial ? 1 : 0);

    for (let i = 0; i < fullStars; i++) {
      html += `<svg class="star-icon" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
    }

    if (hasPartial) {
      const gradId = 'partialStar-' + Math.random().toString(36).substr(2, 9);
      html += `<svg class="star-icon star-icon--partial" viewBox="0 0 24 24">
        <defs><linearGradient id="${gradId}"><stop offset="${partialPercent}%" stop-color="#B15639"/><stop offset="${partialPercent}%" stop-color="rgba(190, 140, 115, 0.25)"/></linearGradient></defs>
        <path fill="url(#${gradId})" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>`;
    }

    for (let i = 0; i < emptyStars; i++) {
      html += `<svg class="star-icon star-icon--empty" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`;
    }

    return html;
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /* There is no server endpoint for helpful votes on this storefront. Keep one
     honest, reversible browser-local vote instead of inventing a global count.
     The server-provided count remains the base; only this browser's own choice
     is added, persisted and restored. */
  const helpfulMemoryVotes = {};

  function helpfulStorageKey(reviewId) {
    return `ss-review-helpful-v1:${PRODUCT_HANDLE}:${reviewId}`;
  }

  function readHelpfulVote(reviewId) {
    try {
      const value = localStorage.getItem(helpfulStorageKey(reviewId));
      if (value === 'up' || value === 'down') return value;
    } catch (e) {}
    return helpfulMemoryVotes[reviewId] || '';
  }

  function saveHelpfulVote(reviewId, vote) {
    helpfulMemoryVotes[reviewId] = vote;
    try {
      if (vote) localStorage.setItem(helpfulStorageKey(reviewId), vote);
      else localStorage.removeItem(helpfulStorageKey(reviewId));
    } catch (e) {}
  }

  function paintHelpfulGroup(group, vote) {
    if (!group) return;
    group.querySelectorAll('.helpful-btn').forEach(btn => {
      const selected = btn.dataset.helpfulType === vote;
      const count = btn.querySelector('span');
      const base = parseInt(btn.dataset.helpfulBase || '0', 10) || 0;
      btn.classList.toggle('active', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (count) count.textContent = String(base + (selected ? 1 : 0));
    });
  }

  function prepareHelpfulButtons(root) {
    if (!root) return;
    root.querySelectorAll('.helpful-btns').forEach(group => {
      if (group.dataset.helpfulReady === '1') return;
      group.dataset.helpfulReady = '1';
      const first = group.querySelector('.helpful-btn');
      const reviewId = first?.dataset.reviewId || '';
      group.querySelectorAll('.helpful-btn').forEach(btn => {
        btn.type = 'button';
        btn.dataset.helpfulBase = String(parseInt(btn.querySelector('span')?.textContent || '0', 10) || 0);
      });
      paintHelpfulGroup(group, readHelpfulVote(reviewId));
    });
  }

  // ════════════════════════════════════════════════════════════════════════��══════
  // RENDERING
  // ═══════════════════════════════════════════════════════════════════════════════

  function renderFeaturedReview(review) {
    if (!elements.featuredReview || !review) return;

    const avatar = elements.featuredReview.querySelector('[data-avatar]');
    const name = elements.featuredReview.querySelector('[data-name]');
    const context = elements.featuredReview.querySelector('[data-context]');
    const stars = elements.featuredReview.querySelector('[data-stars]');
    const verified = elements.featuredReview.querySelector('[data-verified]');
    const date = elements.featuredReview.querySelector('[data-date]');
    const content = elements.featuredReview.querySelector('[data-content]');
    const productEl = elements.featuredReview.querySelector('[data-product]');
    const productName = elements.featuredReview.querySelector('[data-product-name]');
    const upCount = elements.featuredReview.querySelector('[data-up-count]');
    const downCount = elements.featuredReview.querySelector('[data-down-count]');

    if (avatar) avatar.textContent = getInitials(review.name);
    if (name) name.textContent = review.name;
    if (context) context.textContent = review.context || '';
    if (stars) stars.innerHTML = generateStars(review.rating);
    if (verified) verified.style.display = review.verified ? 'inline-flex' : 'none';
    if (date) date.textContent = formatDate(review.date);

    // Support HTML in body for highlights and emphasis
    if (content) {
      content.innerHTML = `<p>${review.body.replace(/\n\n/g, '</p><p>')}</p>`;

      // Add photo if available (featured review = index 1)
      const photoUrl = REVIEW_PHOTOS[1];
      if (photoUrl) {
        const existingPhoto = content.querySelector('.review-photo');
        if (!existingPhoto) {
          const photoAlt = (T.photo_from || 'Photo from {name}').replace('{name}', review.name);
          // A BOUNDED THUMBNAIL THAT OPENS THE FULL PICTURE.
          // These are customer phone screenshots already cropped square on
          // upload (Hojari's is served 600x600), so the thumbnail looked cut
          // mid-frame with no way to see the rest. The bounded frame stays -- a
          // wall of raw tall uploads is not a review list -- but it is now a
          // link to the file, so the crop costs the reader nothing.
          const photoHtml = `<div class="review-photo"><a href="${photoUrl}" target="_blank" rel="noopener" aria-label="${photoAlt}"><img src="${photoUrl}" alt="${photoAlt}" loading="lazy"></a></div>`;
          content.insertAdjacentHTML('beforeend', photoHtml);
        }
      }
    }

    // Product purchased
    if (productEl && productName) {
      if (review.product) {
        productEl.style.display = 'inline-flex';
        productName.textContent = review.product;
      } else {
        productEl.style.display = 'none';
      }
    }

    // Helpful counts: only the stored counts plus this browser's reversible vote.
    if (upCount) upCount.textContent = review.helpful ? review.helpful.up : 0;
    if (downCount) downCount.textContent = review.helpful ? review.helpful.down : 0;
    prepareHelpfulButtons(elements.featuredReview);

    // The card ships [hidden] so it is never an empty outline stop; it has content now.
    elements.featuredReview.hidden = false;
  }

  function renderReviewCard(review, index) {
    const isNew = review.source === 'judgeme';
    const upCount = review.helpful ? review.helpful.up : 0;
    const downCount = review.helpful ? review.helpful.down : 0;
    const reviewId = review.id || `review-${index}`;

    // Photo index: grid reviews start at index 0 (in grid), but they're reviews 2-12 in our data
    // index 0 in grid = review 2 = REVIEW_PHOTOS[2], index 1 = review 3 = REVIEW_PHOTOS[3], etc.
    const reviewIndex = index + 2;
    const photoUrl = REVIEW_PHOTOS[reviewIndex];
    // Same bounded-thumbnail-plus-link treatment as the featured card above.
    const photoHtml = photoUrl ? `<div class="review-photo"><a href="${photoUrl}" target="_blank" rel="noopener" aria-label="Photo from ${escapeHtml(review.name)}"><img src="${photoUrl}" alt="Photo from ${escapeHtml(review.name)}" loading="lazy"></a></div>` : '';

    return `
      <article class="review-card" data-review-id="${reviewId}">
        <div class="review-author">
          <div class="author-avatar">${getInitials(review.name)}</div>
          <div class="author-details">
            <h4 class="author-name">
              ${escapeHtml(review.name)}
              ${isNew ? `<span class="new-badge">${T.new_badge}</span>` : ''}
            </h4>
            ${review.context ? `<div class="author-context">${escapeHtml(review.context)}</div>` : ''}
            <div class="review-meta">
              <div class="review-stars">${generateStars(review.rating)}</div>
              ${review.verified ? `
                <span class="verified-badge">
                  <svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
                  ${T.verified}
                </span>
              ` : ''}
              <span class="review-date">${formatDate(review.date)}</span>
            </div>
          </div>
        </div>
        <div class="review-content">
          <p>${review.body}</p>
          ${photoHtml}
        </div>
        <div class="helpful-actions">
          <span class="helpful-label">${T.helpful}</span>
          <div class="helpful-btns">
            <button type="button" class="helpful-btn" data-helpful-type="up" data-review-id="${reviewId}" aria-pressed="false">👍 <span>${upCount}</span></button>
            <button type="button" class="helpful-btn" data-helpful-type="down" data-review-id="${reviewId}" aria-pressed="false">👎 <span>${downCount}</span></button>
          </div>
        </div>
      </article>
    `;
  }

  function renderReviewsGrid() {
    if (!elements.reviewsGrid) return;

    // Featured is index 0, grid reviews start at index 1
    const gridReviews = allReviews.slice(1);
    const nextBatch = gridReviews.slice(visibleCount, visibleCount + BATCH_SIZE);

    if (nextBatch.length === 0) {
      updateLoadMoreState(true);
      return;
    }

    const html = nextBatch.map((review, i) => renderReviewCard(review, visibleCount + i)).join('');
    elements.reviewsGrid.insertAdjacentHTML('beforeend', html);
    prepareHelpfulButtons(elements.reviewsGrid);

    visibleCount += nextBatch.length;

    /* Translation replaces the indicator's innerHTML, so the spans captured at
       init are detached after first render. Rebuild the live sentence itself on
       every batch rather than updating stale span references. */
    updateReviewsCountIndicator();

    // Check if all loaded
    if (visibleCount >= gridReviews.length) {
      updateLoadMoreState(true);
    }
  }

  function updateLoadMoreState(allLoaded) {
    if (!elements.loadMoreArea) return;

    if (allLoaded) {
      elements.loadMoreArea.classList.add('all-loaded');
      const indicator = elements.loadMoreArea.querySelector('.reviews-count-indicator');
      if (indicator) {
        indicator.textContent = replacePlaceholder(T.showing_all, 'total', totalWrittenReviews());
      }
    } else {
      elements.loadMoreArea.classList.remove('all-loaded');
    }
  }

  // Update the reviews count indicator text
  function updateReviewsCountIndicator() {
    const indicator = section.querySelector('[data-reviews-count-indicator]');
    if (indicator) {
      let text = replacePlaceholder(T.showing_of, 'visible', visibleCount + 1);
      text = replacePlaceholder(text, 'total', totalWrittenReviews());
      indicator.textContent = text;
    }
  }

  // Update the header text "Based on X verified reviews"
  function updateReviewCountText() {
    const countText = section.querySelector('[data-review-count-text]');
    if (countText) {
      const result = replacePlaceholder(T.based_on_reviews, 'count', `<span data-review-count>${TOTAL_RATINGS}</span>`);
      countText.innerHTML = result;
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // EVENT DELEGATION FOR HELPFUL BUTTONS, No inline handlers
  // ═══════════════════════════════════════════════════════════════════════════════

  function setupEventDelegation() {
    // A swipe that starts on a thumb can still arrive as a click. If the page
    // moved while the finger was down, it was a scroll, not a vote.
    let helpfulPressScrollY = null;
    section.addEventListener('pointerdown', function(e) {
      helpfulPressScrollY = e.target.closest('.helpful-btn') ? window.scrollY : null;
    }, { passive: true });
    section.addEventListener('pointercancel', function() {
      helpfulPressScrollY = null;
    }, { passive: true });

    section.addEventListener('click', function(e) {
      const helpfulBtn = e.target.closest('.helpful-btn');
      if (!helpfulBtn) return;
      const pressScrollY = helpfulPressScrollY;
      helpfulPressScrollY = null;
      if (pressScrollY !== null && Math.abs(window.scrollY - pressScrollY) > 4) return;

      const btnsContainer = helpfulBtn.closest('.helpful-btns');
      if (!btnsContainer) return;

      const reviewId = helpfulBtn.dataset.reviewId || '';
      const selected = readHelpfulVote(reviewId);
      const nextVote = selected === helpfulBtn.dataset.helpfulType ? '' : helpfulBtn.dataset.helpfulType;
      saveHelpfulVote(reviewId, nextVote);
      paintHelpfulGroup(btnsContainer, nextVote);
      if (window.SSBehavior && typeof window.SSBehavior.emit === 'function') {
        window.SSBehavior.emit('review_helpful_changed', {
          helpful: nextVote || 'none',
          review_key: reviewId,
          product: location.pathname
        });
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // RATING DISTRIBUTION ANIMATION, Fixed with IntersectionObserver
  // ═══════════════════════════════════════════════════════════════════════════════

  function initDistributionAnimation() {
    // Distribution bars now use CSS attribute selectors for width
    // No JS animation needed - widths are set via data-width attribute in CSS
    // This function is kept for potential future enhancements
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // MODAL FUNCTIONALITY, Fixed selectors
  // ═══════════════════════════════════════════════════════════════════════════════

  let modalReturnFocus = null;

  function trapModalTab(e) {
    /* Keep Tab inside the dialog while it is open. Without this a keyboard
       user tabs straight out into the dimmed page behind the overlay. */
    if (e.key !== 'Tab' || !elements.modal) return;
    const focusables = elements.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function openModal() {
    if (elements.modalOverlay) {
      modalReturnFocus = document.activeElement;
      elements.modalOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      elements.modal?.addEventListener('keydown', trapModalTab);

      setTimeout(() => {
        const firstInput = elements.modal?.querySelector('input, textarea');
        if (firstInput) firstInput.focus();
        /* Hidden star radios refuse focus silently; a dialog must still
           receive it, or the trap has nothing to hold. */
        if (!elements.modal?.contains(document.activeElement)) {
          elements.modal?.querySelector('[data-close-modal]')?.focus();
        }
      }, 100);
    }
  }

  function closeModal() {
    if (elements.modalOverlay) {
      elements.modalOverlay.classList.remove('active');
      document.body.style.overflow = '';
      elements.modal?.removeEventListener('keydown', trapModalTab);
      /* Hand focus back to whatever opened the dialog, so a keyboard user
         is not dropped at the top of the document. */
      if (modalReturnFocus && document.contains(modalReturnFocus)) modalReturnFocus.focus();
      modalReturnFocus = null;
    }
  }

  function resetForm() {
    if (elements.reviewForm) {
      elements.reviewForm.reset();
      elements.reviewForm.style.display = '';
    }
    if (elements.reviewSuccess) {
      elements.reviewSuccess.classList.remove('active');
    }
    if (elements.formError) {
      elements.formError.classList.remove('visible');
      elements.formError.textContent = '';
    }
    const submitBtn = elements.reviewForm?.querySelector('.submit-btn');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = `<span>${T.submit_review}</span> <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`;
    }
  }

  function showError(message) {
    if (elements.formError) {
      elements.formError.textContent = message;
      elements.formError.classList.add('visible');
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // FORM SUBMISSION, Google Sheets Integration
  // ═══════════════════════════════════════════════════════════════════════════════

  const WEBHOOK_URL = CFG.webhookUrl;
  const PRODUCT_TITLE = CFG.productTitle;

  // Convert file to base64
  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function submitReview(formData) {
    if (!WEBHOOK_URL) {
      console.warn('Reviews webhook URL not configured');
      return { success: false };
    }

    /* Two webhook species live behind reviews_webhook_url. The sacrasoul-reviews
       Worker accepts ONLY multipart/form-data (media -> R2, review -> D1) and
       rejects JSON with a 400 — which `no-cors` would hide, so the shopper would
       see "thank you" over a discarded review. The legacy Apps Script endpoint
       reads a JSON body and never sends CORS headers, so it keeps the opaque
       no-cors POST. Route by endpoint; check the Worker's real response. */
    if (/\.workers\.dev\//.test(WEBHOOK_URL)) {
      try {
        const fd = new FormData();
        fd.append('product', PRODUCT_TITLE);
        fd.append('handle', PRODUCT_HANDLE || '');
        fd.append('locale', LOCALE || '');
        fd.append('rating', formData.rating);
        fd.append('title', formData.title || '');
        fd.append('name', formData.name || '');
        fd.append('email', formData.email || '');
        fd.append('review', formData.body || '');
        fd.append('url', window.location.href);
        if (formData.file && formData.file.size > 0 && formData.file.size <= 100 * 1024 * 1024) {
          fd.append('media', formData.file, formData.file.name);
        }
        const res = await fetch(WEBHOOK_URL, { method: 'POST', body: fd });
        if (!res.ok) throw new Error('review submit rejected: ' + res.status);
        return { success: true };
      } catch (error) {
        console.warn('Review submission failed:', error);
        return { success: false };
      }
    }

    try {
      const payload = {
        product: PRODUCT_TITLE,
        name: formData.name,
        email: formData.email,
        rating: formData.rating,
        title: formData.title || '',
        review: formData.body,
        url: window.location.href,
        mediaUrl: formData.mediaUrl || ''
      };

      // Handle file upload if present
      if (formData.file && formData.file.size > 0) {
        if (formData.file.size > 10 * 1024 * 1024) {
          console.warn('File too large (max 10MB)');
          return { success: false };
        }
        try {
          payload.fileData = await fileToBase64(formData.file);
          payload.fileName = formData.file.name;
        } catch (fileErr) {
          console.error('File conversion failed:', fileErr);
        }
      } else {
      }

      await fetch(WEBHOOK_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      return { success: true };
    } catch (error) {
      console.warn('Review submission failed:', error);
      return { success: false };
    }
  }

  async function handleFormSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const submitBtn = form.querySelector('.submit-btn');

    const fileInput = form.querySelector('input[name="media"]');
    const formData = {
      rating: form.querySelector('input[name="rating"]:checked')?.value,
      name: form.querySelector('input[name="name"]')?.value?.trim(),
      email: form.querySelector('input[name="email"]')?.value?.trim(),
      title: form.querySelector('input[name="title"]')?.value?.trim(),
      body: form.querySelector('textarea[name="body"]')?.value?.trim(),
      file: fileInput?.files?.[0] || null,
      mediaUrl: form.querySelector('input[name="mediaUrl"]')?.value?.trim()
    };

    // Validate
    if (!formData.rating) {
      showError(T.error_rating);
      return;
    }
    if (!formData.name || !formData.email || !formData.body) {
      showError(T.error_fields);
      return;
    }

    // Clear previous errors
    if (elements.formError) {
      elements.formError.classList.remove('visible');
    }

    submitBtn.disabled = true;
    submitBtn.innerHTML = T.submitting;

    /* Submit to the collection endpoint. The result decides what the shopper sees:
       telling someone their review landed when nothing was posted is the one failure
       mode a review wall must never have. A missing webhook URL (an unconfigured
       section) returns success:false here and lands in the same error state. */
    const result = await submitReview(formData);

    if (!result || !result.success) {
      showError(T.error_submit);
      submitBtn.disabled = false;
      submitBtn.innerHTML = `<span>${T.submit_review}</span> <svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`;
      return;
    }

    // Show success state
    form.style.display = 'none';
    if (elements.reviewSuccess) {
      elements.reviewSuccess.classList.add('active');
    }

    // Close modal after delay
    setTimeout(() => {
      closeModal();
      setTimeout(resetForm, 400);
    }, 2500);
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // TRANSLATION LOADING
  // ═══════════════════════════════════════════════════════════════════════════════

  /* Dead while TRANSLATION_URLS is empty — TRANSLATIONS_URL is always null, so
     this returns on its first line. Kept, unrefactored, as the staging path for
     a future locale that is not yet server-rendered. */
  async function loadTranslations() {
    if (!TRANSLATIONS_URL) return;

    try {
      /* Asset URLs already carry Shopify's content hash, so '?v=' + Date.now()
         only guaranteed a CDN miss AND a browser-cache miss: this file is the
         same one snippets/translation-init.liquid already fetched, so every
         non-English view downloaded it twice. Share that snippet's in-flight
         map instead — one request, cached across navigations. */
      window.__sacrasoulTranslationFetches = window.__sacrasoulTranslationFetches || {};
      if (!window.__sacrasoulTranslationFetches[TRANSLATIONS_URL]) {
        window.__sacrasoulTranslationFetches[TRANSLATIONS_URL] = fetch(TRANSLATIONS_URL)
          .then(function (r) {
            if (!r.ok) throw new Error('Failed to load translations');
            return r.json();
          })
          .catch(function (e) {
            delete window.__sacrasoulTranslationFetches[TRANSLATIONS_URL];
            throw e;
          });
      }
      const data = await window.__sacrasoulTranslationFetches[TRANSLATIONS_URL];
      const reviewsT = data.products?.[CFG.translationKey]?.reviews;

      if (reviewsT) {
        // Load UI string translations
        T = {
          verified: reviewsT.verified || T.verified,
          verified_buyer: reviewsT.verified_buyer || T.verified_buyer,
          verified_reviewer: reviewsT.verified_reviewer || T.verified_reviewer,
          helpful: reviewsT.helpful || T.helpful,
          new_badge: reviewsT.new_badge || T.new_badge,
          today: reviewsT.today || T.today,
          yesterday: reviewsT.yesterday || T.yesterday,
          days_ago: reviewsT.days_ago || T.days_ago,
          week_ago: reviewsT.week_ago || T.week_ago,
          weeks_ago: reviewsT.weeks_ago || T.weeks_ago,
          month_ago: reviewsT.month_ago || T.month_ago,
          months_ago: reviewsT.months_ago || T.months_ago,
          year_ago: reviewsT.year_ago || T.year_ago,
          years_ago: reviewsT.years_ago || T.years_ago,
          showing_of: reviewsT.showing_of || T.showing_of,
          showing_all: reviewsT.showing_all || T.showing_all,
          based_on_reviews: reviewsT.based_on_reviews || T.based_on_reviews,
          error_rating: reviewsT.error_rating || T.error_rating,
          error_fields: reviewsT.error_fields || T.error_fields,
          error_submit: reviewsT.error_submit || T.error_submit,
          submitting: reviewsT.submitting || T.submitting,
          submit_review: reviewsT.submit_review || T.submit_review
        };

        // Translated review bodies, where a chunk carries them (no locale does today)
        if (reviewsT.reviews_data && Array.isArray(reviewsT.reviews_data)) {
          // Transform the translated set to match ALL_REVIEWS structure
          allReviews = reviewsT.reviews_data.map((review, index) => ({
            id: review.id || `ps-${String(index + 1).padStart(3, '0')}`,
            name: review.name,
            context: review.context,
            rating: review.rating || 5, // Honor per-review rating when the locale chunk provides it; default 5
            verified: review.verified === true, // a badge only where an order matches (Sho, 2026-10-23)
            body: review.body,
            date: ALL_REVIEWS[index]?.date || null, // never invent a date
            featured: review.featured || false,
            product: review.product || null,
            helpful: ALL_REVIEWS[index]?.helpful || { up: 0, down: 0 }
          }));
        }

        // Apply placeholder translations for form inputs
        applyPlaceholderTranslations(reviewsT);

        // Update dynamic text elements
        updateReviewCountText();
      }
    } catch (error) {
      console.warn('Sacrasoul Reviews: Could not load translations', error);
    }
  }

  function applyPlaceholderTranslations(reviewsT) {
    // Update input placeholders
    const placeholderMappings = {
      'reviews.name_placeholder': reviewsT.name_placeholder,
      'reviews.email_placeholder': reviewsT.email_placeholder,
      'reviews.review_title_placeholder': reviewsT.review_title_placeholder,
      'reviews.review_placeholder': reviewsT.review_placeholder
    };

    section.querySelectorAll('[data-placeholder-key]').forEach(el => {
      const key = el.getAttribute('data-placeholder-key');
      const translation = placeholderMappings[key];
      if (translation) {
        el.placeholder = translation;
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // THE PUBLISHED COUNT
  // ═══════════════════════════════════════════════════════════════════════════════

  /* Say in the JSON-LD what this page is actually showing.
   *
   * snippets/structured-data-product.liquid can only count the set Liquid
   * printed. Until 2026-09-18 a German wall was not that set: the chunk swap
   * above replaced the 30 English Hojari reviews with 29 German ones, or kept
   * the English 30 when its fetch failed. Every locale is server-rendered now,
   * so this equals the server count; it stays because it is true on any path,
   * and the number published is the number of reviews rendered — the same figure
   * "Showing 7 of N" prints a few lines below.
   *
   * The guards are the server's, kept: never 0, never more written reviews than
   * there are ratings to draw them from. Google drops a whole incoherent
   * AggregateRating, so a bad number costs the ratingCount too; the key is
   * removed instead.
   */
  function publishRenderedReviewCount() {
    if (!PRODUCT_HANDLE) return;
    const node = document.querySelector(
      'script[type="application/ld+json"][data-product-schema="' + PRODUCT_HANDLE + '"]'
    );
    if (!node) return;
    let schema;
    try {
      schema = JSON.parse(node.textContent);
    } catch (e) {
      return; // never leave a page with unparseable structured data
    }
    const rating = schema && schema.aggregateRating;
    if (!rating) return; // nothing published, nothing to correct
    const rendered = allReviews.length;
    const ratings = parseInt(rating.ratingCount, 10);
    if (rendered > 0 && Number.isFinite(ratings) && rendered <= ratings) {
      rating.reviewCount = rendered;
    } else {
      delete rating.reviewCount;
    }
    node.textContent = JSON.stringify(schema);
  }

  // ═══════════════════════════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════════════════════════

  async function init() {
    // Load translations first (no locale fetches today; every language arrives server-rendered)
    await loadTranslations();

    // Use the translated set if one loaded, otherwise what Liquid rendered
    if (allReviews.length === 0) {
      allReviews = [...ALL_REVIEWS];
    }

    // Render featured review (index 0)
    renderFeaturedReview(allReviews[0]);

    // Initial grid render
    renderReviewsGrid();

    // Update count indicators with proper translations
    updateReviewsCountIndicator();

    // Publish the size of the corpus just rendered, whichever path produced it
    publishRenderedReviewCount();

    // Setup event delegation for helpful buttons
    setupEventDelegation();

    // Load more button
    if (elements.loadMoreBtn) {
      elements.loadMoreBtn.addEventListener('click', renderReviewsGrid);
    }

    // Modal events
    if (elements.openModalBtn) {
      elements.openModalBtn.addEventListener('click', openModal);
    }
    if (elements.closeModalBtn) {
      elements.closeModalBtn.addEventListener('click', closeModal);
    }
    if (elements.modalOverlay) {
      elements.modalOverlay.addEventListener('click', (e) => {
        if (e.target === elements.modalOverlay) {
          closeModal();
        }
      });
    }
    if (elements.reviewForm) {
      elements.reviewForm.addEventListener('submit', handleFormSubmit);
      
      // File input display
      const fileInput = elements.reviewForm.querySelector('input[name="media"]');
      const fileNameDisplay = elements.reviewForm.querySelector('[data-file-name]');
      if (fileInput && fileNameDisplay) {
        fileInput.addEventListener('change', (e) => {
          const file = e.target.files[0];
          if (file) {
            fileNameDisplay.textContent = file.name;
            fileNameDisplay.classList.add('has-file');
          } else {
            fileNameDisplay.textContent = 'No file selected';
            fileNameDisplay.classList.remove('has-file');
          }
        });
      }
    }

    // Escape key to close modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && elements.modalOverlay?.classList.contains('active')) {
        closeModal();
      }
    });

    // Initialize distribution bar animation
    initDistributionAnimation();

    // Variant Selector, Fetch product data if Liquid fallback triggered
    const variantSelector = section.querySelector('[data-variant-selector]');
    const variantInput = section.querySelector('[data-variant-input]');

    if (variantSelector && variantSelector.dataset.needsFetch === 'true') {
      // Liquid all_products failed, fetch product data via JavaScript
      fetch('/products/' + CFG.variantFetchHandle + '.js')
        .then(res => res.json())
        .then(product => {
          if (product && product.variants && product.variants.length > 0) {
            // Build variant buttons
            const firstAvailable = product.variants.find(v => v.available && v.price > 0);
            let buttonsHtml = '';
            product.variants.forEach((variant, index) => {
              const cartCfg = window.SacrasoulCartConfig || {};
              const activeCurrency = cartCfg.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
              let price;
              /* the one money shape: snippets/money.liquid and the drawer's shapeMoney */
              if (typeof window.SacrasoulMoney === 'function') {
                price = window.SacrasoulMoney(variant.price, activeCurrency, document.documentElement.lang || 'en', cartCfg.currency === activeCurrency ? cartCfg.symbol : '');
              } else {
                try {
                  /* whole amounts without ",00", as every Liquid price on the page prints them */
                  const fd = variant.price % 100 === 0 ? 0 : 2;
                  price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: activeCurrency, minimumFractionDigits: fd, maximumFractionDigits: fd }).format(variant.price / 100);
                } catch (formatError) {
                  price = (cartCfg.symbol || '') + (variant.price % 100 === 0 ? String(variant.price / 100) : (variant.price / 100).toFixed(2));
                }
              }
              const disabled = !variant.available ? 'disabled' : '';
              const selected = (firstAvailable && variant.id === firstAvailable.id) ? ' selected' : '';
              buttonsHtml += `
                <button type="button" class="variant-btn${selected}" data-variant-id="${variant.id}" data-variant-price="${price}" ${disabled}>
                  ${variant.title === 'Default Title' ? '' : `<span class="variant-size">${variant.title}</span>`}
                  <span class="variant-price">${price}</span>
                </button>
              `;
            });
            variantSelector.innerHTML = buttonsHtml;

            // Set first variant as default and enable button
            if (variantInput) {
              variantInput.value = firstAvailable ? firstAvailable.id : '';
            }
            const submitBtn = section.querySelector('[data-cta-form] button[type="submit"]');
            if (submitBtn) {
              submitBtn.disabled = !firstAvailable;
            }

            // Add click handler for variant selection
            variantSelector.addEventListener('click', (e) => {
              const btn = e.target.closest('.variant-btn');
              if (!btn || btn.disabled) return;
              variantSelector.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
              btn.classList.add('selected');
              if (variantInput) variantInput.value = btn.dataset.variantId;
            });
          }
        })
        .catch(err => console.error('Failed to load product variants:', err));
    } else if (variantSelector && variantInput) {
      // Normal case, Liquid rendered the variants
      variantSelector.addEventListener('click', (e) => {
        const btn = e.target.closest('.variant-btn');
        if (!btn || btn.disabled) return;

        // Update selected state
        variantSelector.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        // Update hidden input
        variantInput.value = btn.dataset.variantId;
      });
    }

    // CTA Add to Cart, AJAX submission
    const ctaForm = section.querySelector('[data-cta-form]');
    if (ctaForm) {
      ctaForm.addEventListener('submit', async function(e) {
        /* Every add goes through the one serialized gateway. Engine present:
           its document-level interceptor owns the submit. Boot only: queue
           through the shim (masked shell now, serialized on drain). The raw
           fetch below survives only for total script failure. */
        if (window.SacrasoulCart && !window.SacrasoulCart.__isBoot) return;
        if (window.SacrasoulCart && window.SacrasoulCart.addAndOpen) {
          e.preventDefault();
          const bootFd = new FormData(ctaForm);
          const bootId = bootFd.get('id');
          const bootQty = parseInt(bootFd.get('quantity') || '1', 10);
          const bootPreview = window.SacrasoulCart.buildPreview
            ? window.SacrasoulCart.buildPreview(ctaForm, bootId, bootQty)
            : null;
          window.SacrasoulCart.addAndOpen(bootId, bootQty, undefined, bootPreview, bootFd.get('selling_plan') || undefined);
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const submitBtn = ctaForm.querySelector('button[type="submit"]');
        const originalText = submitBtn.innerHTML;

        submitBtn.disabled = true;
        submitBtn.innerHTML = `<span class="loading-spinner"></span> ${T.cta_adding || 'Adding...'}`;

        /* keep the market: a bare '/cart/add.js' from /de-eu/ writes from the
           UK storefront's root (#2393); Shopify.routes.root is this request's
           locale root, the value of routes.root_url */
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cartRoot = shopRoot.charAt(shopRoot.length - 1) === '/' ? shopRoot : shopRoot + '/';

        try {
          const formData = new FormData(ctaForm);
          const response = await fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            body: formData
          });

          if (response.ok) {
            const addedItem = await response.json();
            if (window.SSBehavior && typeof window.SSBehavior.emit === 'function') {
              window.SSBehavior.emit('cart_item_added', {
                source: 'review_cta',
                variant_id: Number(formData.get('id')) || null,
                product_id: addedItem && addedItem.product_id ? Number(addedItem.product_id) : null,
                product_handle: addedItem && addedItem.handle ? addedItem.handle : null,
                quantity: Number(formData.get('quantity') || 1),
                unit_value_cents: addedItem && addedItem.final_price != null
                  ? Number(addedItem.final_price)
                  : (addedItem && addedItem.price != null ? Number(addedItem.price) : null),
                currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || null,
                page: window.location.pathname
              });
            }
            submitBtn.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" fill="none" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> ${T.cta_added || 'Added!'}`;
            submitBtn.classList.add('success');

            // Update cart count if cart icon exists
            const cartCount = document.querySelector('.cart-count, [data-cart-count]');
            if (cartCount) {
              const cartResponse = await fetch(cartRoot + 'cart.js');
              const cartData = await cartResponse.json();
              cartCount.textContent = cartData.item_count;
            }

            // Reset button after delay
            setTimeout(() => {
              submitBtn.innerHTML = originalText;
              submitBtn.disabled = false;
              submitBtn.classList.remove('success');
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          submitBtn.innerHTML = T.cta_error || 'Error, Try Again';
          submitBtn.disabled = false;
          setTimeout(() => {
            submitBtn.innerHTML = originalText;
          }, 2000);
        }
      });
    }
  }

  // Run initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
